export default import.meta.ROLLDOWN_FILE_URL_ZuClYPueozVRanNoK4oa9Q